/**
 * A member's name is stored as it is printed on the card: in capitals.
 *
 * Legacy uppercases the three name fields on the way out of the enrolment form
 * (`normalizeNameInput` in `BasicInfoSection.tsx`), and every screen that shows
 * a member — the detail banner, the printed card — capitalises them again in
 * CSS on the way back in. Only the second half of that was true here: the names
 * went to the API however they were typed and were merely *displayed* shouting,
 * so two clerks entering the same person produced "Dela Cruz" and "DELA CRUZ",
 * which sort apart and read as two people in an export.
 */

/**
 * The same name, in capitals.
 *
 * Case only. Legacy also strips everything outside `[a-zA-Z\s]` on the way
 * through, which is wrong for the members this system holds: it turns PEÑA
 * into PEA, O'BRIEN into OBRIEN and SMITH-JONES into SMITHJONES, silently and
 * while the clerk is still typing. The API puts no character rule on a name
 * (`Short` is a length and nothing else), so neither does this.
 *
 * Length-preserving, which is what lets it run on every keystroke: React
 * restores the caret by offset after it rewrites the value, so a correction
 * typed into the middle of a name stays where it was put.
 */
export const upperName = (value: string): string => value.toUpperCase();
